import { R, toJSON } from "./rational";

export const getCellBackgroundColor = (status) => {
  const colors = {
    open: "#FF0000",
    wip: "orange",
    "n.rel.": "#778899",
    closed: "#7bea7b",
  };
  return colors[status] || null;
};

export const generateId = (deliverables) => {
  if (deliverables.length === 0) return 1;
  return deliverables[deliverables.length - 1].id + 1;
};

export const createNewRow = (id, steps) => {
  const row = {
    id,
    description: "",
    responsible: "",
    weight: toJSON(R(1)),
    fulfillment: toJSON(R(0)),
    showEditDialog: false,
  };

  steps.forEach((step) => {
    row[step.identity] = "open";
  });

  return row;
};
